import * as React from 'react';

export const ContraLogoCondensedIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    fill="none"
    height="41"
    viewBox="0 0 41 41"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M21.0593 19.6008H33.5884C33.7304 19.6008 33.8454 19.4858 33.8454 19.3438V18.9596C33.8454 18.8423 33.7662 18.7402 33.6526 18.7107C27.777 17.201 23.1666 12.6175 21.6198 6.74936C21.5899 6.63653 21.4877 6.55762 21.3712 6.55762H21.0593C20.9173 6.55762 20.8022 6.67267 20.8022 6.81463V19.3438C20.8022 19.4858 20.9173 19.6008 21.0593 19.6008Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.0593 34.1385H21.4435C21.5608 34.1385 21.6633 34.0592 21.6924 33.9457C23.202 28.0705 27.7855 23.4597 33.6541 21.9128C33.7669 21.883 33.8454 21.7808 33.8454 21.6643V21.3523C33.8454 21.2108 33.7304 21.0957 33.5884 21.0957H21.0593C20.9173 21.0957 20.8022 21.2108 20.8022 21.3523V33.8815C20.8022 34.0235 20.9173 34.1385 21.0593 34.1385Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M18.7228 34.1389H19.0343C19.1763 34.1389 19.2914 34.0238 19.2914 33.8815V21.3527C19.2914 21.2108 19.1763 21.0957 19.0343 21.0957H6.50555C6.36358 21.0957 6.24854 21.2108 6.24854 21.3527V21.7366C6.24854 21.8542 6.32781 21.9563 6.44139 21.9858C12.3166 23.4955 16.9273 28.0786 18.4742 33.9471C18.5041 34.06 18.6059 34.1389 18.7228 34.1389Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.50555 19.6008H19.0343C19.1763 19.6008 19.2914 19.4858 19.2914 19.3438V6.81463C19.2914 6.67267 19.1763 6.55762 19.0343 6.55762H18.6505C18.5332 6.55762 18.4307 6.63727 18.4016 6.75084C16.8916 12.626 12.3085 17.2368 6.43991 18.7837C6.32708 18.8132 6.24854 18.9153 6.24854 19.0322V19.3438C6.24854 19.4858 6.36358 19.6008 6.50555 19.6008Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);
